import { apiEndpoints } from '@/lib/api/endpoints'
import { baseApi } from './baseQuery'
import { InsurancePolicy } from '@/types/interfaces/insurance-policy'

export const insurancePolicyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInsurancePolicy: builder.query<InsurancePolicy, void>({
      query: () => apiEndpoints.insurances.getInsurancePolicy,
      keepUnusedDataFor: 300,
    }),
  }),
})

export const { useGetInsurancePolicyQuery } = insurancePolicyApi
